import { useAtom, useAtomValue } from 'jotai';
import CompoundSlider from 'components/CompoundSlider';
import { useDebouncedFn } from 'beautiful-react-hooks';
import { useCallback, useEffect } from 'react';
import useRudderStackTrack from 'hooks/useRudderStackTrack';
import useIsMount from 'utils/useIsMount';

export default function AtomSlider({ atom }) {
  const { min, max, label, unit, step, pushable, valueAtom } = useAtomValue<Record<string, unknown>>(atom);

  // eslint-disable-next-line
  const [value, setValue] = useAtom<unknown>(valueAtom as any);
  const setValueDebounced = useDebouncedFn<() => void>(setValue);

  const onChangeCallback = useCallback((newValue) => {
    // @ts-ignore
    setValue(newValue);

    // @ts-ignore
    setValueDebounced(newValue);
  }, []);

  const rudderTrack = useRudderStackTrack();
  const isMount = useIsMount();
  useEffect(() => {
    if (!isMount) {
      rudderTrack('slider_change_search', {
        value,
        label,
      });
    }
  }, [value]);

  return (
    <CompoundSlider
      min={min}
      max={max}
      unit={unit}
      pushable={pushable}
      defaultValue={value}
      label={label}
      step={step}
      onChange={onChangeCallback}
    />
  );
}
